module.exports = __webpack_public_path__ + "img/180.684ad254.jpg";